import type { Template } from "@/types";

export const LA_02_H0_V2: Template[] = [
    {
        id: "LA-02-h0v2-01",
        name: "LA 01 - H0V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-02-h0_v2_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 176, y: 39, width: 323, height: 404, rotation: 0, imageRotation: 0 },
            { id: "2", x: 853, y: 39, width: 323, height: 404, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "LA-02-h0v2-02",
        name: "LA 02 - H0V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-02-h0_v2_02.png",
         size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 176, y: 39, width: 323, height: 404, rotation: 0, imageRotation: 0 },
            { id: "2", x: 820, y: 0, width: 389, height: 483, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "LA-02-h0v2-03",
        name: "LA 03 - H0V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-02-h0_v2_03.png",
         size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 853, y: 39, width: 323, height: 404, rotation: 0, imageRotation: 0 },
            { id: "2", x: 143, y: 0, width: 389, height: 483, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "LA-02-h0v2-04",
        name: "LA 04 - H0V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-02-h0_v2_04.png",
         size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 143, y: 0, width: 389, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 820, y: 0, width: 389, height: 483, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "LA-02-h0v2-05",
        name: "LA 05 - H0V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-02-h0_v2_05.png",
         size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 143, y: 0, width: 389, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 964, y: 0, width: 389, height: 483, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "LA-02-h0v2-06",
        name: "LA 06 - H0V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-02-h0_v2_06.png",
         size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 820, y: 0, width: 389, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 0, width: 389, height: 483, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "LA-02-h0v2-07",
        name: "LA 07 - H0V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-02-h0_v2_07.png",
         size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 389, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 964, y: 0, width: 389, height: 483, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "LA-02-h0v2-08",
        name: "LA 08 - H0V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-02-h0_v2_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 172, y: 36, width: 332, height: 412, rotation: 0, imageRotation: 0 },
            { id: "2", x: 917, y: 121, width: 193, height: 240, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "LA-02-h0v2-09",
        name: "LA 09 - H0V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-02-h0_v2_09.png",
         size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 848, y: 36, width: 332, height: 412, rotation: 0, imageRotation: 0 },
            { id: "2", x: 241, y: 121, width: 193, height: 240, rotation: 0, imageRotation: 0 }
        ],
    },
   
];

